import { render, staticRenderFns } from "./shareBottomComp.vue?vue&type=template&id=74121184&scoped=true&"
import script from "./shareBottomComp.vue?vue&type=script&lang=js&"
export * from "./shareBottomComp.vue?vue&type=script&lang=js&"
import style0 from "./shareBottomComp.vue?vue&type=style&index=0&id=74121184&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74121184",
  null
  
)

export default component.exports